module.exports = __webpack_public_path__ + "media/105.5bdeaa41.mp3";